const PlatformTypeEnum = {
  APP_STORE: 1,
  PLAY_STORE: 2,
  ALL: 3,

  cases() {
    return {
      [this.ALL]: 'All',
      [this.APP_STORE]: 'App Store',
      [this.PLAY_STORE]: 'Play Store',
    };
  },

  ids() {
    return Object.keys(this.cases()).map(Number);
  },

  names() {
    return Object.values(this.cases());
  },

  fromId(id) {
    return this.cases()[id] || null;
  },

  toId(name) {
    const cases = this.cases();
    return Object.keys(cases).find((key) => cases[key] === name) || null;
  },

  isValidId(id) {
    return this.ids().includes(id);
  },
  
  getAllOptions(includeAll = false) {
    const options =  Object.entries(this.cases()).map(([id, name]) => ({
      id: Number(id),
      name,
    }));
    if (!includeAll) {
      return options.filter(option => option.name !== 'All');
    }
    return options;
  },
  
};

export default PlatformTypeEnum;
